import React, { Component } from "react";
import about from "../pic_about.png";
class About extends Component {


  render() {
    const dictionaryHexColor = {
      1.00: "FF",
      0.90: "E6",
      0.80: "CC",
      0.70: "B3",
      0.60: "99",
      0.50: "80",
      0.40: "66",
      0.30: "4D",
      0.20: "33",
      0.10: "1A",
      0.00: "00"
    }
    const tupleList = [
      [0, 0.1],
      [0.1, 0.2],
      [0.2, 0.3],
      [0.3, 0.4],
      [0.4, 0.5],
      [0.5, 0.6],
      [0.6, 0.7],
      [0.7, 0.8],
      [0.8, 0.9],
      [0.9, 1.0],
    ];
    const col1 = "#1A0315"
    const col2 = "#88D317"
    return (
      <div className="container overflow-scroll">
        <br></br>
        <h2>Overview</h2>
        <p>
          ENACTdb (Exon Nomenclature Annotation and Classification in Transcripts database) is a database which gives detailed splicing event annotation of protein coding transcripts for 5 model organisms;{" "}
          <i>
            Homo sapiens, Mus musculus, Caenorhabditis elegans, Danio rerio, </i>{" "}
          and <i>Drosophila melanogaster</i> sourced from NCBI (Nov 2022).
          <br /><br />

          Protein coding genes for the above-listed organisms can be queried using the 'name'/'symbol' of a gene or its EntrezID. Similarities and differences amongst different gene transcripts can be compared and analyzed using the exonic representation of transcripts. For every gene, three views are generated, described below and containing a dynamic choice of user-generated transcripts.

        </p>
        <ul>
          <li>
            <span className="nav-link active"
              style={{ fontSize: 20, fontWeight: "normal", color: "#dc3545", color: "#b37d4e" }}>
              <b>Exon Details</b>
            </span>View renders each transcript in exon blocks and shows amino acid sequence as default, with a choice to render disordered region, secondary structure, and Pfam domains while maintaining the same blocks. Hovering over any exon will entail its nomenclature and depiction in the render box (sticking to right of screen).
          </li>
          <br /><br />
          <li>
            <span className="nav-link active"
              style={{ fontSize: 20, fontWeight: "normal", color: "#dc3545", color: "#b37d4e" }}>
              <b>Nightingale Tracks</b>
            </span>We have repurposed the protvista/nightingale tracks sourced from <a target="_blank" href="https://ebi-webcomponents.github.io/nightingale">https://ebi-webcomponents.github.io/nightingale</a> and used its domain and fetaure tracks to render our information to exons, iin follwing tracks.
          </li>

          <ul>
            <li>
              {" "}
              <u>Exon track</u>: track shows coding exons and colors them alternately to <span className="badge align-center mx-2" style={{ width: "50px", color: col2, background: col2 }}>.</span> and <span className="badge align-center mx-2" style={{ width: "50px", color: col1, background: col1 }}>.</span>. The ordering of colors is not scaled to exonic ranks and is used only to demarcate their boundaries. Noncoding/UTR exons are not shown here and have coordinates either 0-0 if at N terminal side and length-length if at the Cter side. Partial coding exons with some contribution in addition to CDS at terminal sides are marked with zagged boundaries. The opacity of colors <span className="badge align-center mx-2" style={{ width: "50px", color: col2, background: col2 }}>.</span> and <span className="badge align-center mx-2" style={{ width: "50px", color: col1, background: col1 }}>.</span> are scaled to the inclusion frequency of exons. For alternate exons, the color will correspond to how often and rarely this participate in gene transcripts. Shades, as per their inclusion frequency, are shown below.
            </li>
            <div className="container" align="middle">
              {/* <img
              src={about}
              style={{ height: "40%", width: "40%", objectFit: "contain" }}
            /> */}
              <table>
                <thead>
                  <tr>
                    <th style={{ padding: '20px' }}>Inclusion frequency</th>
                    <th style={{ padding: '20px' }}>Shade Green</th>
                    <th style={{ padding: '20px' }}>Shade Plum</th>
                  </tr>
                </thead>
                <tbody>
                  {tupleList.map((tuple, i) => (
                    <tr key={i}>
                      <td style={{ paddingLeft: '20px', textAlign: 'center' }}>{tuple[0]} - {tuple[1]}</td>
                      <td>
                        <span className="badge align-center mx-2"
                          style={{ width: "100px", color: col2 + dictionaryHexColor[tuple[1]], background: col2 + dictionaryHexColor[tuple[1]] }}>
                          .</span>
                      </td>
                      <td>
                        <span className="badge align-center mx-2"
                          style={{ width: "100px", color: col1 + dictionaryHexColor[tuple[1]], background: col1 + dictionaryHexColor[tuple[1]] }}>
                          .</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <br />
            <li>
              <u>Domain track</u>: predicted Pfam domains with eval less than 0.01 are rendered here
            </li>
            <li>
              <u>Secondary structure and disorder track</u>: separate secondary structure and predicted disorder region tracks are also shown here.
            </li>
            <li>
              <u> Data Table</u>: collapsible table view and provide detailed coordinates of individual entities (predicted SS, disorder region, exons, and domains), cross-mapping to Pfam and nomenclature delineation.
            </li>
          </ul>
          <p className="text-dark"><small>In case of no disorder prediction, domain prediction, or secondary structure region, empty tracks will be reflected. </small></p>
          <br />
          <li>
            <span className="nav-link active"
              style={{ fontSize: 20, fontWeight: "normal", color: "#dc3545", color: "#b37d4e" }}>
              <b>Alignment View</b>
            </span> Using all anchor exon positions of a gene as columns, we have rendered isoforms as badges of exons they contain and also emphasized their block 1 and 3 properties (block 2 is ranked in anchor exons defined above, and constitutive/alternate nature, more in exon Nomenclature section). The color of badges was varied primarily by block 1, UTMD properties
            <ul>
              <li>
                <b>U and -2 </b> are depicted by
                <span className="badge align-center mx-2" style={{ width: "50px", color: '#cdcdcd', background: '#cdcdcd' }}>U-2</span>
              </li>
              <li>
                <b>[TD]</b> and 1 by
                <span className="badge align-center mx-2" style={{ width: "50px", color: '#CFFF8D', background: '#CFFF8D' }}>[TD], 1</span>, and shades of <b>2</b>,<b>3</b>, and <b>4</b> get subsequently darker like
                <span className="badge align-center mx-2" style={{ width: "50px", color: '#A8E890', background: '#A8E890' }}>[TD], 2</span>,
                <span className="badge align-center mx-2" style={{ width: "50px", color: '#9CFF2E', background: '#9CFF2E' }}>[TD], 3</span>, and
                <span className="badge align-center mx-2" style={{ width: "50px", color: '#38E54D', background: '#38E54D' }}>[TD], 4</span>
              </li>
              <li>
                <b>M</b> by
                <span className="badge align-center mx-2 border" style={{ width: "50px", color: 'cornsilk', background: 'cornsilk' }}>M</span>,
                and secondarily by shade change if <b>T</b> and <b>D</b> tags underwent sequence change from an anchor Reference Set Of Exons <b>(RSOEx)</b>, as shown above.
              </li>
            </ul>
            <br />
            Block 3 splice site change will be highlighted by corresponding
            <ul>
              <li>
                <span className="badge align-center mx-2" style={{ border: "double" + "#00303f", borderStyle: "none none none solid", width: "50px", color: '#CFFF8D', background: '#CFFF8D' }}>T,1,n</span>
                for n cases
              </li>
              <li><span className="badge align-center mx-2" style={{ border: "double" + "#00303f", borderStyle: "none solid none none", width: "50px", color: '#CFFF8D', background: '#CFFF8D' }}>T,1,n</span>
                for c cases
              </li>
              <li>
                <span className="badge align-center mx-2" style={{ border: "double " + "#00303f", borderStyle: "none solid none solid", width: "50px", color: '#CFFF8D', background: '#CFFF8D' }}>T,1,n</span>
                for b cases
              </li>
            </ul>
            (shown for variation in block 1 <b>‘T’</b>).
            <br />
            <ul>
              <li>
                Intron retention cases are shown as expansion and column spacing between the start and end exon.
                <br />
                <span>
                  <span className="badge align-center" style={{ marginRight: "100px", width: "50px", color: 'black', background: '#CFFF8D' }}>1</span>
                  <span className="badge align-center" style={{ marginRight: "100px", width: "50px", color: 'black', background: '#CFFF8D' }}>2</span>
                  <span className="badge align-center" style={{ width: "50px", color: 'black', background: '#CFFF8D' }}>3</span>
                </span>
                <br />
                <span className="badge align-center" style={{ width: "350px", color: 'black', background: '#CFFF8D' }}>Retention between 1 and 3</span>
              </li>
            </ul>

            <br />
            <p className="text-secondary"><small>* Inter exon space is not scaled to their intronic distance.</small></p>

          </li>
          <br />
          <li>
            <span className="nav-link active text-primary"
              style={{ fontSize: 20, fontWeight: "normal" }}>
              <b>User Query</b>
            </span>  This module provides a facility for the user-given protein isoform (with or without knowledge of its identifier) to have the exonic delineation as per the nomenclature we have defined for the queried gene.
          </li>
        </ul>
      </div >
    );
  }
}

const buttonStyleOn = {
  fontSize: "22px",
  color: "#1A0315"
}

export default About;
